/**
 * Tarih-saat utility fonksiyonları
 * API'den gelen tüm tarihler UTC (ISO 8601) kabul edilir; gösterim her zaman Türkiye saati (Europe/Istanbul) yapılır.
 */

const TURKEY_TIMEZONE = 'Europe/Istanbul';

/**
 * Tarih string'ini parse eder (UTC olarak kabul edilir)
 */
export const parseUTCDateToTR = (dateString: string): Date => {
  return new Date(dateString);
};

/**
 * UTC tarih string'ini Türkiye saatinde formatlar
 * Format: "DD.MM.YYYY HH:mm:ss"
 */
export const formatDateToTR = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString('tr-TR', {
    timeZone: TURKEY_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};

/**
 * UTC tarih string'ini Türkiye saatinde kısa formatlar (saniye olmadan)
 * Format: "DD.MM.YYYY HH:mm"
 */
export const formatDateToTRShort = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString('tr-TR', {
    timeZone: TURKEY_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

/**
 * Tarihi "X dakika/saat/gün önce" formatında gösterir (UTC anları karşılaştırılır)
 */
export const formatTimeAgoTR = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Az önce';
  if (diffMins < 60) return `${diffMins} dk önce`;
  if (diffHours < 24) return `${diffHours} saat önce`;
  return `${diffDays} gün önce`;
};

/**
 * UTC tarih string'ini Türkiye saatinde sadece saat olarak formatlar (HH:mm)
 */
export const formatTimeOnlyTR = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString('tr-TR', {
    timeZone: TURKEY_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

/**
 * UTC tarih string'ini Türkiye saatinde sadece tarih olarak formatlar (DD.MM.YYYY)
 */
export const formatDateOnlyTR = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString('tr-TR', {
    timeZone: TURKEY_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
